'use strict';

// TODO: Refactor so accountService is used and we can set accountId from currentAccountId

angular.module('ringbaPortal.services').factory('campaignServiceNew', campaignServiceNew);

function campaignServiceNew(
  _,
  $http,
  $q,
  $translate,
  accountsService,
  ngAuthSettings,
  payoutService,
  featureFlags,
  promiseCacheService
) {
  'ngInject';

  const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

  const columnSettings = {
    id: {
      hide: true,
      class: 'max-width-80',
      stSort: '',
      displayName: 'CAMPAIGNS_ID',
      rowAlign: 'left'
    },
    status: {
      class: 'column-sortable',
      stSort: 'combinedStatus.displayOrder',
      displayName: 'CAMPAIGNS_STATUS',
      rowAlign: 'center'
    },
    name: {
      class: 'column-sortable',
      stSort: 'name',
      displayName: 'CAMPAIGNS_NAME',
      displayNameForPublisher: 'CAMPAIGNS_NAME_PUBLISHER',
      rowAlign: 'left'
    },
    countryCode: {
      class: 'column-sortable',
      stSort: 'pool.assignmentSettings.countryCode',
      displayName: 'CAMPAIGNS_COUNTRY',
      rowAlign: 'center'
    },
    recording: {
      displayName: 'CAMPAIGNS_RECORDING',
      rowAlign: 'center',
      hideForUserType: ['affiliate', 'affiliate_manager']
    },
    currentLive: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentLive',
      displayName: 'CAMPAIGNS_LIVE',
      rowAlign: 'right'
    },
    currentHour: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentHour',
      displayName: 'CAMPAIGNS_HOUR',
      rowAlign: 'right'
    },
    currentDay: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentDay',
      displayName: 'CAMPAIGNS_DAY',
      rowAlign: 'right'
    },
    currentMonth: {
      class: 'tablesort-sortable text-right',
      stSort: 'currentDay',
      displayName: 'CAMPAIGNS_MONTH',
      rowAlign: 'right'
    },
    total: {
      class: 'tablesort-sortable text-right',
      stSort: 'total',
      displayName: 'CAMPAIGNS_TOTAL',
      rowAlign: 'right'
    },
    offerName: {
      class: 'column-sortable',
      stSort: 'offer.name',
      displayName: 'CAMPAIGNS_OFFER_NAME',
      rowAlign: 'left',
      hideForUserType: ['affiliate', 'affiliate_manager']
    },
    offerTitle: {
      class: 'column-sortable',
      stSort: 'offer.name',
      displayName: 'CAMPAIGNS_OFFER_TITLE',
      rowAlign: 'left',
      hideForUserType: ['admin', 'affiliate_manager']
    }
  };

  const statusProperties = {
    'live': {
      text: 'LIVE_TEXT',
      className: 'label-success',
      displayOrder: '1.1',
      showOfferSummary: false,
      tooltipForAdmin: 'CAMPAIGN_LIVE_ADMIN',
      tooltipRtbForAdmin: 'CAMPAIGN_LIVE_ADMIN',
      tooltipForPublisherCampaign: 'CAMPAIGN_LIVE_PUBLISHER',
      tooltipForPublisherOffer: 'OFFER_LIVE_PUBLISHER'
    },
    'offerPaused': { // This is when an offer is paused for publishers only
      text: 'OFFER_PAUSED_TEXT',
      className: 'label-warning',
      displayOrder: '2.1',
      showOfferSummary: false,
      tooltipForPublisherOffer: 'OFFER_PAUSED_PUBLISHER'
    },
    'campaignPaused': {
      text: 'CAMPAIGN_PAUSED_TEXT',
      textForPublisher: 'CAMPAIGN_PAUSED_PUBLISHER_TEXT',
      className: 'label-warning',
      displayOrder: '2.2',
      showOfferSummary: false,
      tooltipForAdmin: 'CAMPAIGN_PAUSED_ADMIN',
      tooltipForPublisherCampaign: 'CAMPAIGN_PAUSED_PUBLISHER'
    },
    'setup': {
      text: 'SETUP_TEXT',
      className: 'label-danger',
      displayOrder: '3.1',
      showOfferSummary: false,
      tooltipForAdmin: 'CAMPAIGN_SETUP_ADMIN',
      tooltipForPublisherCampaign: 'CAMPAIGN_SETUP_PUBLISHER'
    },
    'addNumber': {
      text: 'ADD_OFFER_NUMBER_TEXT',
      className: 'label-success',
      displayOrder: '1.2',
      showOfferSummary: false,
      tooltipForPublisherCampaign: 'CAMPAIGN_ADD_NUMBER_PUBLISHER',
      tooltipForPublisherOffer: 'CAMPAIGN_ADD_NUMBER_PUBLISHER'
    },
    'expired': {
      text: 'EXPIRED_TEXT',
      className: 'label-warning',
      displayOrder: '2.3',
      showOfferSummary: false,
      tooltipForPublisherOffer: 'OFFER_EXPIRED_PUBLISHER'
    },
    'apply': {
      text: 'APPLY_TEXT',
      className: 'label-default',
      displayOrder: '0.1',
      showOfferSummary: true,
      tooltipForPublisherOffer: 'OFFER_APPLY_PUBLISHER'
    },
    'join': {
      text: 'JOIN_TEXT',
      className: 'label-default',
      displayOrder: '0.2',
      showOfferSummary: true,
      tooltipForPublisherOffer: 'OFFER_JOIN_PUBLISHER'
    },
    'declined': {
      text: 'DECLINED_APPROVAL_TEXT',
      className: 'label-danger',
      displayOrder: '3.2',
      showOfferSummary: true,
      tooltipForPublisherOffer: 'OFFER_DECLINED_PUBLISHER'
    },
    'pending': {
      text: 'PENDING_APPROVAL_TEXT',
      className: 'label-warning',
      displayOrder: '2.4',
      showOfferSummary: true,
      tooltipForPublisherOffer: 'OFFER_PENDING_PUBLISHER'
    }
  };

  const defaultColumns = ['id', 'status', 'name', 'offerTitle', 'offerName', 'countryCode', 'recording', 'currentLive', 'currentHour', 'currentDay', 'currentMonth', 'total', 'isComplete'];
  const dashboardDefaultColumns = ['status', 'name', 'countryCode', 'isComplete'];
  
  if (featureFlags.isOn('rtb')) {
    columnSettings.rtbStatus = {
      class: 'column-sortable',
      stSort: 'rtb.enabled',
      displayName: 'CAMPAIGNS_RTB_STATUS',
      rowAlign: 'left',
    };

    defaultColumns.splice(3, 0, 'rtbStatus');
  }

  const dashboardColumnSettings = {
    name: _.cloneDeep(columnSettings.name),
    countryCode: _.cloneDeep(columnSettings.countryCode),
    isComplete: _.cloneDeep(columnSettings.isComplete),
    status: _.cloneDeep(columnSettings.status)
  };

  const duplicateSettings = [
    {
      name: 'Connect',
      duplicateSetting: 'ON_CONNECT'
    },
    {
      name: 'Incoming',
      duplicateSetting: 'ON_INCOMMING'
    },
    {
      name: 'Call Length Greater Than',
      duplicateSetting: 'ON_CALL_LENGTH'
    }
  ];

  const service = {
    getCampaigns: getCampaigns,
    getCompletedCampaigns: getCompletedCampaigns,
    getCampaign: getCampaign,
    createCampaign: createCampaign,
    duplicateCampaign: duplicateCampaign,
    deleteCampaign: deleteCampaign,
    updateCampaign: updateCampaign,
    updateStrikePriceSchedule: updateStrikePriceSchedule,
    link: link,
    unLink: unLink,
    defaultNumber: defaultNumber,
    addRoute: addRoute,
    deleteRoute: deleteRoute,
    setCompleted: setCompleted,
    hasWebhooks: hasWebhooks,
    isValid: isValid,
    columnSettings: columnSettings,
    defaultColumns: defaultColumns,
    dashboardColumnSettings: dashboardColumnSettings,
    dashboardDefaultColumns: dashboardDefaultColumns,
    countryCodeForCampaign: countryCodeForCampaign,
    setDefaultPayout: setDefaultPayout,
    checkCampaignReferences: checkCampaignReferences,
    getCampaignsStats: getCampaignsStats,
    addIVR: addIVR,
    removeIVR: removeIVR,
    setRoutingType: setRoutingType,
    serviceBaseUrl: serviceBaseUrl,
    duplicateSettings: duplicateSettings,
    getCampaignStatus: getCampaignStatus,
    getCampaignVerticals: getCampaignVerticals,
    statusProperties: statusProperties,
    checkIfCampaignsExistOnAccount: checkIfCampaignsExistOnAccount
  };

  return service;

  function getCampaigns(accountId, getStats, getRtbSettings, isUi) {
    if (_canViewCampaigns()) {
      return _getCampaignsFromCachedPromise(accountId, getStats, getRtbSettings, isUi);
    } else {
      const deferred = $q.defer();
      deferred.resolve({
        data: {
          campaigns: []
        }
      });
      return deferred.promise;
    }
  }

  function checkIfCampaignsExistOnAccount(accountId) {
    return getCampaigns(accountId, false).then(function (response) {
      return response && response.data && response.data.campaigns && response.data.campaigns.length > 0;
    });
  }

  function getCompletedCampaigns(accountId) {
    return getCampaigns(accountId).then(function (response) {
      const campaigns = _.filter(response.data.campaigns, function (campaign) {
        return campaign.completed;
      });
      return campaigns;
    });
  }

  function getCampaignsStats(accountId) {
    const url = serviceBaseUri + accountId + '/campaigns/stats';
    return $http.get(url);
  }

  function getCampaign(accountId, campaignId, includeIntegrationSettings) {
    const url = serviceBaseUrl(accountId, campaignId) + '?includeIntegrationSettings=' + !!includeIntegrationSettings;
    return $http.get(url).then(function (response) {
      if (response.data.campaign && response.data.campaign.defaultPayouts) {
        response.data.campaign.defaultPayouts = payoutService.sanitizePayoutsForDisplay(response.data.campaign.defaultPayouts);
        //Includes the pubNumberEnrichmentUrls into the campaign object
        response.data.campaign.pubNumberEnrichmentUrls = response.data.pubNumberEnrichmentUrls;
      }
      if (response.data.campaign.eventCallBacks && response.data.campaign.eventCallBacks.length > 0) {
        _.each(response.data.campaign.eventCallBacks, function (item) {
          item.method = item.method.toUpperCase();
          item.advanced = item.method.toUpperCase() != 'GET' || (item.headers != null && Object.keys(item.headers).length > 0);
        });
      }
      return response;
    });
  }

  function createCampaign(accountId, campaign) {
    const data = _sanitizeCampaign(campaign);
    const url = serviceBaseUri + accountId + '/campaigns';
    return $http.post(url, data)
      .then(function (response) {
        _cleanAccountCampaignsCache(accountId);
        return response;
      });
  }

  function duplicateCampaign(accountId, campaignId) {
    const url = serviceBaseUrl(accountId, campaignId) + '/clone';
    return $http.post(url)
      .then(function (response) {
        _cleanAccountCampaignsCache(accountId);
        return response;
      });
  }

  function deleteCampaign(accountId, campaignId, forceDelete, keepNumbers) {
    let url = serviceBaseUrl(accountId, campaignId);
    url = url + '?force=' + !!forceDelete + '&keepNumbers=' + keepNumbers;
    return $http.delete(url).then(function (response) {
      _cleanAccountCampaignsCache(accountId);
      return response;
    });
  }

  function updateCampaign(accountId, campaign) {
    const url = serviceBaseUrl(accountId, campaign.id);
    const data = _sanitizeCampaign(campaign);
    return $http.patch(url, data)
      .then(function (response) {
        _cleanAccountCampaignsCache(accountId);
        return response;
      });
  }

  // Strike prices are not part of _sanitizeCampaign: the server takes them as their own
  // settings object, and patching them alongside the rest of the campaign would persist
  // unsaved edits from other sections of the page.
  function updateStrikePriceSchedule(accountId, campaignId, schedule) {
    const url = serviceBaseUrl(accountId, campaignId);
    return $http.patch(url, { strikePriceSettings: { schedule: schedule } })
      .then(function (response) {
        _cleanAccountCampaignsCache(accountId);
        return response;
      });
  }

  // Members which can be linked
  // QueryMapPath  - memberName: 'qpathmaps'
  // EventCallBack - memberName: 'eventCallBacks'
  // NumberPools   - memberName: 'pool'
  function link(accountId, campaignId, memberId, memberName) {
    const url = serviceBaseUrl(accountId, campaignId) + '/link';
    const data = { memberName: memberName, memberId: memberId };
    return $http.patch(url, data);
  }

  function unLink(accountId, campaignId, memberId, memberName) {
    const url = serviceBaseUrl(accountId, campaignId) + '/unLink';
    const data = { memberName: memberName, memberId: memberId };
    return $http.patch(url, data);
  }

  function setDefaultPayout(accountId, campaignId, payoutSetting) {
    const url = serviceBaseUrl(accountId, campaignId) + '/defaultPayout';
    const data = payoutSetting;
    return $http.post(url, data);
  }

  function defaultNumber(accountId, campaignId, numberId) {
    const url = serviceBaseUrl(accountId, campaignId) + '/DefaultNumber';
    const data = { numberId: numberId };
    return $http.patch(url, data);
  }

  function addRoute(accountId, campaignId, route) {
    const url = serviceBaseUrl(accountId, campaignId) + '/Routes';
    return $http.post(url, route);
  }

  // TODO: API
  function deleteRoute(accountId, campaignId, routeId) {
    const url = serviceBaseUrl(accountId, campaignId) + '/Routes';
    return $http({
      method: 'DELETE',
      url: url,
      data: { id: routeId },
      headers: {
        'Content-type': 'application/json'
      }
    });
  }

  // TODO: Implement this where we are validating campaign data
  function isValid(campaign) {
    let hasRoutes = false;
    let resolvedEventCallBacks = false;
    if (campaign.routes && campaign.routes.length > 0) {
      hasRoutes = true;
      if (hasWebhooks(campaign)) {
        if (campaign.eventCallBacks && campaign.eventCallBacks.length > 0) {
          // TODO: Add additional check for event code is = answered
          resolvedEventCallBacks = true;
        }
      } else {
        resolvedEventCallBacks = true;
      }
    }
    return hasRoutes && resolvedEventCallBacks;
  }

  function setCompleted(accountId, campaignId) {
    const url = serviceBaseUrl(accountId, campaignId);
    const data = { completed: true };
    return $http.patch(url, data);
  }

  function hasWebhooks(campaign) {
    let hasWebhook = false;
    if (campaign && typeof campaign.routes !== 'undefined' && campaign.routes.length > 0) {
      _.forEach(campaign.routes, function (route) {
        if (route.conversionSettings[0].conversionType === 'postBack') {
          hasWebhook = true;
        }
      });
    }
    return hasWebhook;
  }

  function countryCodeForCampaign(campaign, emptyValue) {
    if (campaign) {
      if (campaign.countryCode) {
        return campaign.countryCode;
      } else if (campaign.pool && campaign.pool.assignmentSettings) {
        return campaign.pool.assignmentSettings.countryCode;
      } else if (campaign.defaultNumber && campaign.defaultNumber.assignmentSettings) {

        return campaign.defaultNumber.assignmentSettings.countryCode;
      }
    }
    return typeof emptyValue !== 'undefined' ? emptyValue : '';
  }

  function checkCampaignReferences(accountId, campaignId) {
    let url = serviceBaseUrl(accountId, campaignId);
    url = url + '/InboundReferences';
    return $http.get(url);
  }

  function addIVR(accountId, campaignId, treeId) {
    const url = serviceBaseUrl(accountId, campaignId) + '/IVRTree';
    const data = { ivrTreeId: treeId };
    return $http.post(url, data);
  }

  function removeIVR(accountId, campaignId) {
    const url = serviceBaseUrl(accountId, campaignId) + '/IVRTree';
    return $http.delete(url);
  }

  function setRoutingType(accountId, campaignId, type) {
    const url = serviceBaseUrl(accountId, campaignId) + '/RoutingType';
    const data = { routingType: type };
    return $http.post(url, data);
  }

  function serviceBaseUrl(accountId, campaignId) {
    return serviceBaseUri + accountId + '/campaigns/' + campaignId;
  }

  function getCampaignStatus(campaign, isAffiliate) {
    let statusObj = {};
    if (campaign) {
      const offerStatus = isAffiliate ? _getOfferStatus(campaign.offer) : undefined;
      statusObj = _getStatusUIObject(offerStatus, campaign.enabled, campaign.completed);
      statusObj.text = isAffiliate && statusObj.textForPublisher ? $translate.instant(statusObj.textForPublisher) : $translate.instant(statusObj.text);
      statusObj.isOffer = !!(isAffiliate && campaign.offer && campaign.enabled);
    }
    return statusObj;
  }

  function getCampaignVerticals(accountId) {
    const url = serviceBaseUri + accountId + '/campaigns/verticals';
    return $http.get(url);
  }

  function _getStatusUIObject(offerStatus, isCampaignEnabled, isCampaignCompleted) {
    if (!isCampaignEnabled || !isCampaignCompleted || !offerStatus) {
      return _returnCampaignStatus(isCampaignEnabled, isCampaignCompleted);
    }

    return _getCampaignStatusUIFromObject(offerStatus);
  }

  function _returnCampaignStatus(isCampaignEnabled, isCampaignCompleted) {
    if (!isCampaignCompleted) {
      return _getCampaignStatusUIFromObject('setup');
    } else if (!isCampaignEnabled) {
      return _getCampaignStatusUIFromObject('campaignPaused');
    } else {
      return _getCampaignStatusUIFromObject('live');
    }
  }

  function _getOfferStatus(offer) {
    if (!offer) {
      return;
    } else if (offer.offerState !== 'enabled') {
      return offer && offer.offerState === 'paused' ? 'offerPaused' : offer.offerState; // return expired or paused offer state from here
    }

    return _getOfferParticipationStatus(offer.offerParticipationStatus, offer.publisherHasNumber);
  }

  function _getCampaignStatusUIFromObject(key) {
    return angular.copy(statusProperties[key]);
  }

  function _getOfferParticipationStatus(participationStatus, publisherHasNumber) {

    switch(participationStatus) {
    case 'available-with-approval':
      return 'apply';

    case 'available':
      return 'join';

    case 'enrolled':
      return publisherHasNumber ? 'live' : 'addNumber';
      
    case 'pending':
      return 'pending';

    case 'declined':
      return 'declined';
      
    default:
      return;
    }

  }

  function _sanitizeCampaign(campaign) {
    const sanitized = {
      id: campaign.id,
      completed: campaign.completed,
      hangupRerouteSetting: campaign.hangupRerouteSetting,
      rpcSetting: campaign.rpcSetting
    };

    if (campaign.name) { sanitized.name = campaign.name; }
    sanitized.verticalId = campaign.verticalId ? campaign.verticalId : '';
    if (campaign.recordSetting) { sanitized.recordSetting = campaign.recordSetting; }
    if (campaign.transcriptionSettings && accountsService.isAdmin()) {
      sanitized.transcriptionSettings = campaign.transcriptionSettings;
    }
    if (campaign.callAnalysisSettings && accountsService.isAdmin()) {
      sanitized.callAnalysisSettings = campaign.callAnalysisSettings;
    }
    if (typeof campaign.userCampaignId !== 'undefined') { sanitized.userCampaignId = campaign.userCampaignId; }
    if (typeof campaign.enabled !== 'undefined') { sanitized.enabled = campaign.enabled; }
    if (campaign.deDupeSettings) { sanitized.deDupeSettings = campaign.deDupeSettings; }
    if (campaign.duplicateSettings) { sanitized.duplicateSettings = campaign.duplicateSettings; }
    if (campaign.converstionSettings) { sanitized.converstionSettings = campaign.converstionSettings; }
    if (campaign.dialSettings) { sanitized.dialSettings = campaign.dialSettings; }
    if (typeof campaign.numberDisplayFormat !== 'undefined') { sanitized.numberDisplayFormat = campaign.numberDisplayFormat; }
    if (typeof campaign.evalAnonymDuplication !== 'undefined') { sanitized.evalAnonymDuplication = campaign.evalAnonymDuplication; }
    
    if (typeof campaign.payoutDupesGlobal !== 'undefined') { 
      sanitized.payoutDupesGlobal = campaign.payoutDupesGlobal; 
    }

    const countryCode = countryCodeForCampaign(campaign);

    if(countryCode) {
      campaign.countryCode = sanitized.countryCode = countryCode;
    }
      
      
    if (campaign.spamDetection) { 
      sanitized.spamDetection = campaign.spamDetection; 
    }

    if (typeof campaign.filterCallsThroughTCPAShield !== 'undefined') {
      sanitized.filterCallsThroughTCPAShield = campaign.filterCallsThroughTCPAShield; 
    }

    if (typeof campaign.playTCPAWarningMessage !== 'undefined') {
      sanitized.playTCPAWarningMessage = campaign.playTCPAWarningMessage; 
    }

    if (typeof campaign.shakenStirAllowedAttestations !== 'undefined') {
      sanitized.shakenStirAllowedAttestations = campaign.shakenStirAllowedAttestations; 
    }

    if (campaign.shareableTagSetting != null) {
      sanitized.shareableTagSetting = campaign.shareableTagSetting;
    }

    return sanitized;
  }

  function _canViewCampaigns() {
    return !accountsService.isBuyer();
  }

  function _cleanAccountCampaignsCache(accountId) {
    // We have to clean all variations of account-wise cache of the campaigns list.

    let key = _getCacheKey(accountId, false);
    promiseCacheService.clean(key);

    key = _getCacheKey(accountId, true);
    promiseCacheService.clean(key);
  }

  function _getCampaignsFromCachedPromise(accountId, getStats, getRtbSettings,isUi) {
    //blocks from same page load calling the server multiple
    //times
    const key = _getCacheKey(accountId, getStats, getRtbSettings);
    const ui = isUi ? '/ui' : '';
    const url = serviceBaseUri + accountId + '/campaigns' +ui+ '?includestats=' + (getStats ? 'true' : 'false') + '&includeDI=' + (getRtbSettings ?'true':'false') + '&includeRTB='+  (getRtbSettings ?'true':'false');
    return promiseCacheService.getCallWithCachedPromise(key, url, 5);
  }

  function _getCacheKey(accountId, getStats, getRtbSettings) {
    return 'campaignGetPromise' + accountId + (getStats ? 'includestats' : '') + (getRtbSettings ? 'includeDI' : '');
  }
}
